import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Layout from '../../../shared-ui/layouts/standard'
import LightLogo from '../assets/images/logo/light-logo.png'
import DarkLogo from '../assets/images/logo/logo-cuatrotorres-v2.png'
import { Container, Box, Row, Col } from '../../../shared-ui/components//ui/wrapper'
import Heading from '../../../shared-ui/components//ui/heading'
import { BannerArea, BannerBgArea, BannerTextWrap } from './inner-page.style'
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge" // Bridget between the old Gatsby Image and the new one.
import { BgImage } from 'gbimage-bridge';

const InnerPageLayout = ({children, location, bannerImg, browserTitle, pageData, metaImage }) => {  
  
  const titleStyle = {
        as: 'h1',
        color: '#fff',
        mb: '15px'
    };

  const taglineStyle = {
        as: 'h5',
        fontweight: 400,
        color: '#fff'
  };

  // The BackgroundImage component is still using the old way for referencing images
  // so, something had to be done to convert it to suppor the new way to reference images.
  // This in particular dropped the support for "fluid" images.
  // This documentation helped to made this conversion
  // https://www.gatsbyjs.com/plugins/gatsby-background-image/
  // https://github.com/timhagn/gatsby-background-image/tree/main/packages/gbimage-bridge 
  // https://www.gatsbyjs.com/docs/reference/release-notes/image-migration-guide/
  const image = getImage(bannerImg);
  const bgImageConverted = convertToBgImage(image);

  const { allHeadermenuJson, allFootermenuJson, allHeadlineJson, site } = useStaticQuery(graphql`
        query GET_INNER_PAGE_CONTENT {
            
            allHeadermenuJson {
                edges {
                    node {
                        text
                        link
                        id                        
                    }
                }
            }
            allFootermenuJson {
              edges {
                  node {
                      text
                      link
                      id
                      submenu {
                        link
                        text
                      }
                  }
              }
          }
          allHeadlineJson {
              edges {
                node {
                  isVisible
                  introText
                  text
                  link
              }
            }
          }
          site {
              siteMetadata {
                  title
                  description
                  author
                  siteUrl
                  canonical
                  siteLanguage
                  image
                  titleTemplate
                  twitterUsername

                  copyright
                    contact {
                        phone
                        email
                        address
                        website
                    }
                    social {
                        facebook
                        twitter
                        instagram
                        linkedin
                    }
              }
              buildTime
            }
        } 
    `);

  return (
    <Layout browserTitle={browserTitle} location={location} menuData={allHeadermenuJson} 
        headline={allHeadlineJson.edges[0].node} footerMenu={allFootermenuJson} site={site} lightLogo={LightLogo} darkLogo={DarkLogo} metaImage={metaImage} >           
        <BannerArea {...bgImageConverted} preserveStackingContext >
            <Container>
                <Row justify="center">
                    <Col lg={8}>
                        <BannerTextWrap>
                            {pageData.title && <Heading {...titleStyle}>{pageData.title}</Heading>}
                            {pageData.tagline && <Heading {...taglineStyle}>{pageData.tagline}</Heading>}
                        </BannerTextWrap>                        
                    </Col>
                </Row>
            </Container>
        </BannerArea>        
      {children}
    </Layout>)
}

export default InnerPageLayout